import { useNavigate } from 'react-router-dom'

import SearchInput from '../components/form/search/Input'
import PageSection from '../components/layout/PageSection'
import SearchResults from '../containers/content/search/results'
import { useSearch } from '../../libraries/search/hook'
import * as utilsLib from '../../libraries/utils'
import { useI18N } from '../../libraries/i18n/hook'

/**
 * URL: /search-mobile/:content?q=foo
 *
 * /search-mobile?q=foo
 * /search-mobile/videos?q=foo
 * /search-mobile/documents?q=foo
 *
 * @urlParams
 * :content indicates which tab is active in UI,
 * (if empty defaults to 'all' tab.)
 *
 * @queryParams
 * q: search query
 */
const SearchPage = () => {
  const navigate = useNavigate()
  const { q } = useSearch()
  const { t } = useI18N()

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    navigate(`/search-mobile?q=${e.target.value}`, { replace: true })
  }

  const debouncedHandleSearch = utilsLib.debounceFunc(handleSearch, 500)

  return (
    <div>
      <PageSection title='Que Necesitas?' showCloseIcon>
        <div className='overflow-hidden'>
          <SearchInput
            defaultValue={q}
            onSubmit={(value) => navigate(`/search-mobile?q=${value}`, { replace: true })}
            bg='bg-white'
            onChange={debouncedHandleSearch}
            placeholder={t('content.searchMobile')}
            showResetIcon
          />
        </div>
        <div className='my-6' />
        <SearchResults basePath='search-mobile' />
      </PageSection>
    </div>
  )
}

export default SearchPage
